import React from 'react';
import { IncludedRelationshipProvider } from 'Views/Page/Contexts/IncludedRelationshipContext';
import PropTypes from 'prop-types';
import Container from './Container';

const IncludedRelationshipContent = ({
  resource,
  relationship,
  onActionClick,
  showAction,
}) => {
  return (
    <IncludedRelationshipProvider
      relationship={relationship}
    >
      <Container
        resource={resource}
        onActionClick={onActionClick}
        showAction={showAction}
      />
    </IncludedRelationshipProvider>
  );
};

IncludedRelationshipContent.propTypes = {
  resource: PropTypes.object.isRequired,
  relationship: PropTypes.object.isRequired,
  onActionClick: PropTypes.func.isRequired,
  showAction: PropTypes.func.isRequired,
};

export default IncludedRelationshipContent;
